import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { serializeAxiosError } from 'app/shared/reducers/reducer.utils';

const initialState = {
  loading: false,
  registrationSuccess: false,
  registrationFailure: false,
  errorMessage: null,
  successMessage: null,
};

export type RegisterState = Readonly<typeof initialState>;

// Actions

export interface RegisterPayload {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  langKey?: string;
  dateOfBirth?: string;
  parentEmail?: string;
  phoneNumber?: string;
  countryCode?: string;
  isoCode?: string;
}

export const handleRegister = createAsyncThunk(
  'register/create_account',
  async (data: RegisterPayload) => axios.post<any>('api/register', data),
  { serializeError: serializeAxiosError }
);

export const RegisterSlice = createSlice({
  name: 'register',
  initialState: initialState as RegisterState,
  reducers: {
    reset() {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleRegister.pending, state => {
        state.loading = true;
      })
      .addCase(handleRegister.rejected as any, (_state: any, action: any) => ({
        ...initialState,
        registrationFailure: true,
        errorMessage: action.error.message,
        successMessage: action,
      }))
      .addCase(handleRegister.fulfilled as any, (_state: any, action: any) => ({
        ...initialState,
        registrationSuccess: true,
        successMessage: action.payload.data,
      }));
  },
});

export const { reset } = RegisterSlice.actions;

// Reducer
export default RegisterSlice.reducer;
